import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const LogEmailIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "LogEmail",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M10.86 9.57c0-.59-.48-1.08-1.08-1.08H7.5V6.2c0-.59-.48-1.08-1.08-1.08S5.34 5.6 5.34 6.2v2.28H3.07c-.59 0-1.08.48-1.08 1.08s.48 1.08 1.08 1.08h2.28v2.3c0 .59.48 1.08 1.08 1.08s1.08-.48 1.08-1.08v-2.28h2.28c.59 0 1.08-.48 1.08-1.08Zm16.5 3.66H11.42c-1.46 0-2.64 1.18-2.64 2.64v8.37c0 1.46 1.18 2.64 2.64 2.64h15.94c1.46 0 2.64-1.18 2.64-2.64v-8.37c0-1.46-1.18-2.64-2.64-2.64m-1.09 10.64a.74.74 0 0 1-.55-.24l-2.76-2.69-1.56 1.36c-.53.47-1.24.77-2.02.77s-1.48-.29-2.02-.77l-1.53-1.36-2.76 2.69a.74.74 0 0 1-.55.24.76.76 0 0 1-.51-1.32l2.69-2.61-2.63-2.36a.76.76 0 0 1 .59-1.24c.15 0 .28.04.4.11l5.32 4.73c.27.24.62.38 1.01.38s.74-.15 1.01-.38l5.33-4.72c.13-.12.31-.19.51-.19.42 0 .76.34.76.76 0 .23-.1.43-.25.57l-2.64 2.36 2.69 2.6c.16.14.25.34.25.57 0 .42-.34.76-.76.76v-.03Z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M27.14 30.57H6.57c-1.89 0-3.43-1.54-3.43-3.43V16.85a1.14 1.14 0 1 1 2.28 0v10.29c0 .63.51 1.14 1.14 1.14h20.57c.63 0 1.14-.51 1.14-1.14V10c0-.63-.51-1.14-1.14-1.14h-9.14a1.14 1.14 0 1 1 0-2.28h9.14c1.89 0 3.43 1.54 3.43 3.43v17.14c0 1.89-1.54 3.43-3.43 3.43Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M7.71 14.57c-.63 0-1.14-.51-1.14-1.14V2a1.14 1.14 0 1 1 2.28 0v11.43c0 .63-.51 1.14-1.14 1.14"
      }), /*#__PURE__*/_jsx("path", {
        d: "M13.43 8.86H2a1.14 1.14 0 1 1 0-2.28h11.43a1.14 1.14 0 1 1 0 2.28M16.62 18.92c-.22 0-.44-.06-.63-.19l-4.37-2.91c-.53-.35-.67-1.06-.32-1.58.35-.53 1.06-.67 1.58-.32l3.74 2.49 7.6-5.07c.52-.35 1.23-.21 1.58.32.35.52.21 1.23-.32 1.58l-8.24 5.49c-.19.13-.41.19-.63.19Z"
      })]
    })
  }));
};
LogEmailIcon.displayName = 'LogEmailIcon';